import React, { useEffect, useState } from "react"
import "react-tooltip/dist/react-tooltip.css"
import Header from "../Header"
import Footer from "../Footer"
import { Helmet } from "react-helmet"
import LoadingOverlay from "react-loading-overlay"
import { Circles } from "react-loader-spinner"
import { Script } from "gatsby"
import ScaleLoader from "react-spinners/ScaleLoader"

const Layout = ({ children }) => {
  useEffect(() => {
    setTimeout(() => {
      document.querySelector(".body-overlay").style.display = "none"
      setIsLoading(false)
    }, 2000)
  }, [])

  const [isLoading, setIsLoading] = useState(true)

  return (
    <>
      <Helmet>
        {/* Google Tag Manager */}
        <script>{`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MD25CSP');
        `}</script>
        {/* End Google Tag Manager */}

        {/* Klavyio  */}
        {/* <script
          async
          type="text/javascript"
          src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Vg7Ucn"
        ></script> */}
      </Helmet>

      <Header />

      <div className="body-overlay">
        {/* <img
            // src="https://alignerbase-public.s3.us-east-2.amazonaws.com/alignerbase-animation-splash.gif"
            src="https://alignerbase-public.s3.us-east-2.amazonaws.com/alignerbase-web-nav-logo.png"
            width="400px"
          />*/}
        {/* <LoadingOverlay
              active={isLoading}
              spinner={<Circles color="#43ACCB" />}
            /> */}
        <ScaleLoader
          // css={override}
          size={250}
          color="#43ACCB"
          loading={isLoading}
        />
      </div>

      {/* <div
        className="body-overlay"
        style={{ minHeight: "100vh", display: "grid", placeContent: "center" }}
      >
        <ScaleLoader
          css={override}
          size={250}
          color="#43ACCB"
          loading={isLoading}
        />
      </div> */}

      <div className="mx-auto">
        <div className="main-container">{children}</div>
      </div>

      <Footer />

      {/* HubSpot Embed Code */}
      {/* <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-na1.hs-scripts.com/24158283.js"
      ></Script> */}
      {/* End HubSpot Embed Code */}

      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-MD25CSP"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      {/* End Google Tag Manager (noscript) */}
    </>
  )
}

export default React.memo(Layout)
